import React from 'react';
import clsx from 'clsx';

import downCaret from '../images/caret-down.svg';
import magnifyChart from '../images/magnify-chart.svg';
import './SidebarCategory.scss';

function SidebarCategory(props) {
    const isActiveCategory = props.activeView !== null && props.activeView.categoryName === props.name;

    return (
        <>
            <button
                type="button"
                className={clsx("btn w-100 text-left sidebar-category",
                    isActiveCategory && "active")}
                onClick={() => props.toggle(props.name)}
                aria-expanded={props.isOpen}
                aria-controls={`${props.name}-nav`}>
                <img
                    src={magnifyChart}
                    alt={props.name}
                    className="svg-image category" />
                {` ${props.name} `}
                {props.isOpen &&
                    <img
                        src={downCaret}
                        alt="Open/Close Category"
                        className="svg-image caret open" />
                }
            </button>
            <ul
                id={`${props.name}-nav`}
                className={clsx("sidebar-views nav flex-column", !props.isOpen && "hidden")}
                aria-hidden={!props.isOpen}>
                {props.views.map((view) =>
                    <li className="nav-item w-100" key={view.viewName}>
                        <button
                            className={clsx("btn link nav-link",
                                isActiveCategory && props.activeView.displayName === view.displayName && "active")}
                            tabIndex={props.isOpen ? 0 : -1}
                            onClick={() => props.setActiveView(view)}>
                            {view.displayName}
                        </button>
                    </li>
                )}
            </ul>
        </>
    );
}

export default SidebarCategory;